export const CARD_WIDTH = 354
export const MOBILE_WIDTH_BREAKPOINT = 768 // should match: $utk-search-breakpoints, small
export const GAP = 20
export const ESTIMATED_ASSET_ROW_HEIGHT = 364
export const CARD_HEIGHT = 354
